import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OrderAbandonDialogComponent } from '@x/ecommerce-shop/app/core/order/components/order-abandon-dialog/order-abandon-dialog.component';
import { OrderState } from '@x/schemas/ecommerce';
import { Observable, of } from 'rxjs';

export enum AbandonOrderDialogResponseEnum {
  Yes = 'yes',
  No = 'no',
  Ignore = 'ignore',
}

export interface AbandonOrderDialogActions {
  label: string;
  response: AbandonOrderDialogResponseEnum;
  buttonType: 'primary' | 'secondary';
}

export interface AbandonOrderDialogConfig {
  title: string;
  message: string;
  closeDialog: boolean;
  actions: AbandonOrderDialogActions[];
  currentOrder: {
    orderId: number | null | undefined;
    orderState: OrderState;
  };
}

@Injectable()
export class AbandonOrderService {
  constructor(private matDialog: MatDialog) {}

  abandonOrder(data: AbandonOrderDialogConfig): Observable<AbandonOrderDialogResponseEnum> {
    const { orderId } = data.currentOrder;
    if (!orderId) return of(AbandonOrderDialogResponseEnum.Yes);

    return this.openAbandonOrderDialog(data);
  }

  private openAbandonOrderDialog(
    data: AbandonOrderDialogConfig,
  ): Observable<AbandonOrderDialogResponseEnum> {
    return this.matDialog
      .open(OrderAbandonDialogComponent, {
        data,
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'fullwidth-dialog-mobile',
      })
      .afterClosed();
  }
}
